module.exports = __webpack_public_path__ + "img/orange_122.09324a92.png";